import React from 'react';
import { Op } from 'contensis-delivery-api';
import contensis from 'Common/api/contensis';
import cmsParser from 'Common/util/cmsParser';
import setCacheHeaders from 'Common/func/setCacheHeaders';
import { excludeMetadata } from 'Common/util/contensis/api';

import Metadata from 'Components/Metadata';
import MainLayout from 'Layout/Main';
import Template, { datamap, PageData } from 'Templates/Accommodation/FindAHome/Residence';

import type { NextPageWithLayout, GetServerSideProps } from 'next';

const Residence: NextPageWithLayout<PageData> = ({ entry, ancestors, residences }) => {
    return (
        <>
            <Metadata {...cmsParser.metadata(entry)} />
            <Template {...datamap({ entry, ancestors, residences })} />
        </>
    );
};

Residence.getLayout = (page, props) => {
    return <MainLayout {...props}>{page}</MainLayout>;
};

export const getServerSideProps: GetServerSideProps<any> = async ({ params, preview, res }) => {
    const { fetch, surrogateKeys } = contensis({ preview, fetchSurrogateKeys: true });
    const { residence } = params as { residence: string };

    const { data, error } = await fetch(async (client, search) => {
        const resPage = await client.nodes.get({
            path: `/accommodation/find-a-home/${residence}`,
            entryLinkDepth: 2,
            entryFields: ['*', ...excludeMetadata]
        });

        if (!resPage.entry) {
            return { error: true };
        }

        const residenceQuery = Op.equalTo('sys.contentTypeId', 'studentResidenceInformation');

        const resResidences = await search(residenceQuery, {
            pageSize: 10,
            linkDepth: 1,
            fields: [
                'listingImage',
                'listingImageLandscape',
                'title',
                'heroBannerImageDefault.heroBannerWaveDefault.postHeading',
                'distanceFromCampus',
                'introText',
                'priceFrom',
                'mapXcoordinate',
                'mapYcoordinate'
            ]
        });

        const ancestors = await client.nodes.getAncestors({
            id: resPage.id,
            entryFields: ['title']
        });

        return {
            entry: resPage.entry,
            ancestors,
            residences: resResidences.items.filter(item => item.sys.uri)
        };
    });

    if (error) {
        return { notFound: true };
    } else {
        setCacheHeaders(res, surrogateKeys);
        return { props: data };
    }
};

export default Residence;
